import React from 'react';

const IconHamburger: React.FC<JSX.IntrinsicElements['svg']> = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.6735 17.3346C22.6735 16.9476 22.3605 16.6346 21.9735 16.6346H2.02754C1.64054 16.6346 1.32654 16.9476 1.32654 17.3346C1.32654 17.7216 1.64054 18.0346 2.02754 18.0346H21.9735C22.3605 18.0346 22.6735 17.7216 22.6735 17.3346ZM22.6735 12.0006C22.6735 11.6136 22.3605 11.3006 21.9735 11.3006H2.02754C1.64054 11.3006 1.32654 11.6136 1.32654 12.0006C1.32654 12.3876 1.64054 12.7006 2.02754 12.7006H21.9735C22.3605 12.7006 22.6735 12.3876 22.6735 12.0006ZM21.9735 7.36658H2.02754C1.64054 7.36658 1.32654 7.05258 1.32654 6.66658C1.32654 6.27958 1.64054 5.96558 2.02754 5.96558H21.9735C22.3605 5.96558 22.6735 6.27958 22.6735 6.66658C22.6735 7.05258 22.3605 7.36658 21.9735 7.36658Z"
      fill="currentColor"
    />
  </svg>
);

export default IconHamburger;
